import React from 'react';
import { motion } from 'framer-motion';
import { Upload, Download } from 'lucide-react';

const UploadSection = ({
  selectedFile,
  uploading,
  uploadProgress,
  loading,
  handleFileSelect,
  handleFileUpload,
  downloadTemplate
}) => {
  return (
    <motion.div 
      className="upload-section"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.7 }}
    >
      <div className="upload-header">
        <h2>Upload Customer Data</h2>
        <p>Upload a CSV file to add customer information. Columns: user_id, full_name, email, phone_number, created_on, pincode, substore. Leave substore empty if not needed.</p>
      </div>

      <div className="upload-container">
        <div className="file-input-wrapper">
          <input
            id="file-input"
            type="file"
            accept=".csv"
            onChange={handleFileSelect}
            className="file-input"
            disabled={loading}
          />
          <label htmlFor="file-input" className="file-input-label" style={{ cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? (
              <>
                <div className="loading-spinner-small"></div>
                Loading...
              </>
            ) : (
              <>
                <Upload size={20} />
                <span>{selectedFile ? selectedFile.name : 'Choose CSV file'}</span>
              </>
            )}
          </label>
        </div>

        <div className="upload-actions">
          <button
            onClick={downloadTemplate}
            className="template-btn"
            disabled={uploading || loading}
          >
            {loading ? (
              <>
                <div className="loading-spinner-small"></div>
                Loading...
              </>
            ) : (
              <>
                <Download size={16} />
                Download Template
              </>
            )}
          </button>

          <button
            onClick={handleFileUpload}
            className="upload-btn"
            disabled={!selectedFile || uploading || loading}
          >
            {uploading ? (
              <>
                <div className="spinner"></div>
                Uploading... {uploadProgress}%
              </>
            ) : loading ? (
              <>
                <div className="loading-spinner-small"></div>
                Loading...
              </>
            ) : (
              <>
                <Upload size={16} />
                Upload File
              </>
            )}
          </button>
        </div>

        {uploading && (
          <div className="upload-progress">
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${uploadProgress}%` }}
              ></div>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default UploadSection;
